import { CanActivate, Router } from '@angular/router'
import { Injectable } from '@angular/core'
import {
  AuthRedirectService,
  AuthService,
  BaseSiteService,
  GlobalMessageService,
  GlobalMessageType,
  OCC_CART_ID_CURRENT,
  OCC_USER_ID_CURRENT,
  RoutingService,
  SemanticPathService,
} from '@spartacus/core'
import { map, switchMap, take, tap } from 'rxjs/operators'
import { MbLogoutService } from '../../shared/services/mb-logout/mb-logout.service'
import { MultiCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root',
})
export class MbCdcAuthGuard implements CanActivate {

  supportsAccountCreation: boolean | undefined
  supportsGuestCheckout: boolean | undefined
  nextPageId: string | undefined

  constructor (protected authService: AuthService,
               protected authRedirectService: AuthRedirectService,
               protected router: Router,
               protected baseSiteService: BaseSiteService,
               protected mbLogoutService: MbLogoutService,
               protected semanticPathService: SemanticPathService,
               protected globalMessageService: GlobalMessageService,
               protected routingService: RoutingService,
               protected multiCartService: MultiCartService) {
  }

  canActivate () {
    // redirect, if user is already logged in:
    return this.baseSiteService.get().pipe(
      tap(baseSite => this.supportsAccountCreation = baseSite?.supportingAccountCreation || false),
      tap(baseSite => this.supportsGuestCheckout = baseSite?.supportingGuestCheckout || false),
      switchMap(() => this.routingService.getNextPageContext()),
      tap(page => this.nextPageId = page?.id),
      switchMap(() => this.authService.isUserLoggedIn()),
      map(isLoggedIn => {
        if (isLoggedIn) {
          if (this.supportsGuestCheckout) {
            if (this.nextPageId?.includes('/checkout')) {
              this.multiCartService.deleteCart(OCC_CART_ID_CURRENT, OCC_USER_ID_CURRENT)
              this.mbLogoutService.logout().pipe(
                take(1),
                tap(() => this.globalMessageService.add({ key: 'mbcart.failedLoggedInCheckout' }, GlobalMessageType.MSG_TYPE_ERROR)),
                tap(() => this.router.parseUrl(this.semanticPathService.get('cart') || ''))
              ).subscribe()
              return false
            } else {
              return true
            }
          }
        } else {
          if (this.supportsGuestCheckout) {
            return true
          }
          if (this.supportsAccountCreation) {
            this.authRedirectService.saveCurrentNavigationUrl()
            this.authService.loginWithRedirect()
            return false
          } else {
            return true
          }
        }

        return isLoggedIn
      })
    )
  }
}
